<template>
  <div class='massLoss-list'>
    <div class='nav' v-loading='pageLoading'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='年月：'>
          <!--<el-date-picker
            v-model='searchForm.years'
            type='month'
            value-format='yyyyMM'
            size='mini'
            placeholder='请选择年月'>
          </el-date-picker>-->
          <el-input v-model='searchForm.startYears' type='number' size='mini' placeholder='请输入年月' />
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-input v-model='searchForm.endYears' type='number' size='mini' placeholder='请输入年月' />
        </el-form-item>
        <el-form-item label='锁定人：'>
          <el-input v-model='searchForm.lockName' type='number' size='mini' placeholder='请输入锁定人' />
        </el-form-item>
        <el-form-item label='锁定状态：'>
          <el-select v-model="searchForm.lockingType" size="mini" filterable style="width: 150px" placeholder="请选择锁定状态">
            <el-option label="全部" value="" />
            <el-option label="未锁定" value="0" />
            <el-option label="锁定" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' class='searchBtn' @click="btnClick('add')">新增</el-button>
          <el-button size='small' class='searchBtn' @click='LockOrUnlock'>锁定/解锁</el-button>
          <el-button size='small' class='searchBtn' @click="btnClick('del')">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          :max-height='tableMaxHeight'
          border
          :header-cell-style='headerCellStyle'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :row-style="rowStyle"
        >
          <el-table-column type='selection' align='center' width='50px' :reserve-selection='true' />
          <el-table-column prop='years' label='年月' align='center' min-width='180px' />
          <el-table-column prop='total' label='总数量' align='center' min-width='150px' />
          <el-table-column prop='totalAmount' label='总金额' align='center' min-width='180px' />
          <el-table-column label='审核状态' align='center' min-width='180px'>
            <template slot-scope='scope'>
              {{ getType(scope.row.auditStatus) }}
            </template>
          </el-table-column>
          <el-table-column label='锁定状态' align='center' min-width='100px'>
            <template slot-scope='scope'>
              {{ scope.row.lockingType ? '锁定' : '未锁定' }}
            </template>
          </el-table-column>
          <el-table-column prop='lockName' label='锁定人' align='center' min-width='180px' />
          <el-table-column label='操作' width='220' align='center' fixed='right'>
            <template slot-scope='scope'>
              <el-button size='mini' type='primary' @click='btnClick("info",scope.row)'>详情
              </el-button>
              <el-button v-if='scope.row.auditStatus === 3 || scope.row.auditStatus === 0'
                         size='mini' type='primary' @click='btnClick("edit",scope.row)'>修改
              </el-button>
              <el-button v-if='scope.row.auditStatus === 1' size='mini' type='warning'
                         @click='btnClick("audit", scope.row)'>审核
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10,25,50]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <commercial-car-plan-form ref='commercialCarPlanFormRef' @searchBtn='searchBtn'
                              :key='commercialCarPlanFormKey' />
  </div>
</template>

<script>
  import {
    commercialCarPlanDelete,
    commercialCarPlanPage, lockUnlock,
  } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import CommercialCarPlanForm from './components/commercialCarPlanForm.vue';

  export default {
    name: 'commercialCarPlan',
    components: {
      CommercialCarPlanForm,
    },
    data() {
      return {
        searchForm: {
          startYears: '',
          endYears: '',
          lockName: '',
          lockingType: '',
          seeType: 0,
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        lineOption: [
          {
          label: '全部',
          value: '',
        },
          {
          label: '未锁定',
          value: '0',
        },
          {
          label: '锁定',
          value: '1',
        }],
        pageLoading: false,
        checkTableData: [],
        commercialCarPlanFormKey: 888,
        windowHeight: 0,
        tableMaxHeight: 650,
      };
    },
    watch: {
      windowHeight() {
        this.getResolution(true);
      },
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));

      this.getResolution();
    },
    methods: {
      getResolution(flag) {
        if (flag) {
          this.windowHeight === 1080 ? this.tableMaxHeight = 650 : this.tableMaxHeight = 380;
          this.$forceUpdate();
          return;
        }
        this.windowHeight = window.screen.height;
      },
      btnClick(str, row) {
        switch (str) {
          case 'add':
            this.commercialCarPlanFormKey += 1;
            this.$nextTick(() => {
              this.$refs.commercialCarPlanFormRef.dialogOpen('新增');
            });
            break;
          case 'info':
            this.commercialCarPlanFormKey += 1;
            this.$nextTick(() => {
              this.$refs.commercialCarPlanFormRef.dialogOpen('详情', row.id);
            });
            break;
          case 'edit':
            this.commercialCarPlanFormKey += 1;
            this.$nextTick(() => {
              this.$refs.commercialCarPlanFormRef.dialogOpen('修改', row.id);
            });
            break;
          case 'audit':
            this.commercialCarPlanFormKey += 1;
            this.$nextTick(() => {
              this.$refs.commercialCarPlanFormRef.dialogOpen('审核', row.id);
            });
            break;
          case 'del':
            this.deleteData();
            break;
        }
      },
      // 删除
      async deleteData() {
        if (this.checkTableData.length === 0) return this.$message.warning('请选择数据后删除');
        this.$confirm('确认删除当前选中数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const ids = [];
            this.checkTableData.forEach(item => {
              ids.push(item.id);
            });
            const {
              status,
              message,
            } = await commercialCarPlanDelete({ ids });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.clearCheckTableData();
          })
          .catch(() => {
          });
      },
      // 锁定/解锁
      async LockOrUnlock() {
        if (this.checkTableData.length === 0) return this.$message.warning('请选择数据后锁定/解锁');
        const ids = [];
        this.checkTableData.forEach(item => {
          ids.push(item.id);
        });
        const {
          status,
          message,
        } = await lockUnlock({ ids: ids });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.clearCheckTableData();
      },
      clearCheckTableData() {
        this.$refs.registerTable.clearSelection();
        this.checkTableData = [];
        this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/commercial/car/plan/exportData?access_token=${token}&startYears=${this.searchForm.startYears}&endYears=${this.searchForm.endYears}`;
        window.exportExcelGet('/platform/commercial/car/plan/exportData', `startYears=${this.searchForm.startYears}&endYears=${this.searchForm.endYears}`);
      },
      getType(type) {
        switch (type) {
          case 0:
            return '已保存';
          case 1:
            return '提交审核';
          case 2:
            return '审核通过';
          case 3:
            return '未通过审核';
          default:
            return '--';
        }
      },
      // 查询
      searchBtn() {
        if (this.searchForm.startYears.length !== this.searchForm.endYears.length) return this.$message.warning('请保持开始日期与结束日期（年/月）一致性！');
        if (this.searchForm.endYears && this.searchForm.startYears && (this.searchForm.endYears < this.searchForm.startYears)) return this.$message.warning('结束日期必须大于等于开始日期！');
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableData = val;
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await commercialCarPlanPage(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow-y: hidden;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
